import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { StockEntry, StockEntryPayload } from "@project/types/gruh-udhyog";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/stock-entries`;
const SILENT: RequestConfig = { showNotification: false };

class GruhUdhyogStockService {
  listPage = (query: ListQuery = {}): Promise<PaginatedResult<StockEntry>> =>
    fetchListPage<StockEntry>(`${BASE}/`, query);

  get = async (id: number): Promise<StockEntry | undefined> => {
    const data = await get<ApiItemResponse<StockEntry> | StockEntry>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (payload: StockEntryPayload): Promise<StockEntry> => {
    const data = await post<
      ApiItemResponse<StockEntry> | StockEntry,
      StockEntryPayload
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(data);
    if (!item) {
      throw new Error("Failed to create stock entry.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<StockEntryPayload>
  ): Promise<StockEntry | undefined> => {
    const data = await patch<
      ApiItemResponse<StockEntry> | StockEntry,
      Partial<StockEntryPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const gruhUdhyogStockService = new GruhUdhyogStockService();
